import React from "react";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NumericCardSettingsStateType, defaultSettings } from "./NumericCardSettings";
import TitleCase from "components/formatting/TitleCase";
import AbbreviateNumber from "components/formatting/AbbreviateNumber";

interface NumericCardPreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: NumericCardSettingsStateType | {};
}

export default function NumericCardPreview(props: NumericCardPreviewProps) {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const currentState = {...defaultSettings, ...props.settingsState};

  const value = 123456.789
  let displayValue = currentState.showDecimals ? value : parseInt(value.toFixed(0));

  return (
    <Stack
      sx={{
        gap: 1,
        width: isSmallScreen ? '100%' : '50%'
      }}>
      {currentState.widgetTitle !== 'none' &&
        <Typography
          sx={{ fontSize: "1.2rem", textAlign: `${currentState.widgetTitleAlignment}` }}
          variant="subtitle2">
          <TitleCase text={currentState.widgetTitle} />
        </Typography>
      }
      {currentState.abbreviate &&
        <AbbreviateNumber
          options={{
            maximumFractionDigits: currentState.showDecimals ? 2 : 0
          }}
          sx={{
            color: currentState.color ?? theme.colors.primary.dark,
            height: "100%",
            position: "relative",
            textAlign: currentState.alignment
          }}
          typographyVariant={isSmallScreen ? 'h3' : 'h1'}
          value={displayValue}
        />
      }
      {!currentState.abbreviate &&
        <Typography
          sx={{
            color: currentState.color ?? theme.colors.primary.dark,
            textAlign: currentState.alignment
          }}
          variant={isSmallScreen ? 'h3' : 'h1'}
        >
          {i18n.t('intlNumber', {
              val: displayValue,
              formatParams: {}
          })}
        </Typography>
      }
    </Stack>
  );
}